var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancerNavigationHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 79,
    viewBox: "0 0 81 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 322",
    d: "M40.7188 70.1045L38.4608 67.8466C27.4295 56.8153 27.4295 38.93 38.4608 27.8987L47.3188 19.0407C53.458 12.9016 63.4115 12.9015 69.5507 19.0407C75.6898 25.1799 75.6898 35.1334 69.5507 41.2726L40.7188 70.1045Z",
    fill: "#306153"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 323",
    d: "M40.8164 70.1045L43.0743 67.8466C54.1056 56.8153 54.1056 38.93 43.0743 27.8987L34.2163 19.0407C28.0772 12.9016 18.1236 12.9015 11.9845 19.0407C5.84532 25.1799 5.84532 35.1334 11.9845 41.2726L40.8164 70.1045Z",
    fill: "#284993"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancerNavigationHeart);
export default __webpack_public_path__ + "static/media/CancerNavigationHeart.cd8ce0941c7e9899b445a09531299723.svg";
export { ForwardRef as ReactComponent };